import {useBreakpoints} from "@vueuse/core";

export const mobileMinWidth = 0;
export const tabletMinWidth = 768;
export const desktopMinWidth = 1200;

export const breakpoints = useBreakpoints({
    tablet: tabletMinWidth,
    desktop: desktopMinWidth,
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    xxl: 2560,
});

export const isMobile = breakpoints.smaller('tablet');
export const isTablet = breakpoints.between('tablet', 'desktop');
export const isDesktop = breakpoints.greater('desktop');
export const xs = breakpoints.greaterOrEqual('xs');
export const sm = breakpoints.greaterOrEqual('sm');
export const md = breakpoints.greaterOrEqual('md');
export const lg = breakpoints.greaterOrEqual('lg');
export const xl = breakpoints.greaterOrEqual('xl');
export const xxl = breakpoints.greaterOrEqual('xxl');